import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";
import Form from 'react-bootstrap/Form';
import Skeleton from 'react-loading-skeleton'
import { useTranslation, Trans } from "react-i18next";
import Modal from 'react-bootstrap/Modal';
import Stack from 'react-bootstrap/Stack';
import FormFileUpload from "./../inputs/fileupload";
import FormSelect from './../inputs/select';
import Button from 'react-bootstrap/Button';
import { Interweave } from 'interweave';

const ConfirmPopup = (props) => {
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    
    useEffect(() => {
        setShow(props.show);        
    }, [props.show]);

    return (

        <Modal show={show} onHide={() => {
            setShow(false);
            props.onClose?.();
        }}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Interweave content={props.body} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>{t("no")}</Button>
                <Button variant={props.isDeleting ? "primary" : "success"} onClick={() => {
                    props.onClose();
                    if (props.onClick) {props.onClick()}
                }}>
                    {t("yes")}</Button>
            </Modal.Footer>
        </Modal>

    );
};

export default observer(ConfirmPopup);
